import { render, staticRenderFns } from "./BannerGridItemWrapper.vue?vue&type=template&id=0c90e1de"
import script from "./BannerGridItemWrapper.vue?vue&type=script&lang=js"
export * from "./BannerGridItemWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports